module.exports = __webpack_public_path__ + "static/19-c8b0671fc4d4cdc7c1b23d7b07dd8e5a.jpg";